<template>
  <div class="dashboard-container" id="food-app">
    <div class="container">
      <div class="tableBar">
        <el-input
          v-model="input"
          placeholder="请输入餐厅名称"
          style="width: 250px"
          clearable
          @keyup.enter="handleQuery"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            style="cursor: pointer"
            @click="init"
          ></i>
        </el-input>

        <el-button type="danger" @click="sousuo"> 搜索</el-button>


        <el-button type="primary" @click="addDOStu"> 新增</el-button>

      </div>



      <el-table
    :data="tableData"
    stripe
    class="tableBox"
    @selection-change="handleSelectionChange"
  >
    <!-- 多选框 -->
    <el-table-column type="selection" width="55"></el-table-column>

    <!-- 书籍序号 -->
    <el-table-column prop="id" label="餐厅序号" width="80"></el-table-column>

    <!-- 书籍名称 -->
    <el-table-column prop="restaurantName" label="餐馆名称" min-width="100"></el-table-column>
   
    <el-table-column
      prop="image"
      label="餐厅图片"
      min-width="100"
    >
    <template #default="scope">
    <img 
      :src="scope.row.image"
      style="width: 250px; height: 120px;" 
    />
  </template>
    </el-table-column>
    <!-- 书籍号 -->
    <el-table-column prop="restaurantAddr" label="餐馆地址" width="100"></el-table-column>

    <!-- 书籍类型 -->
    <el-table-column prop="restaurantPhone" label="餐馆电话" min-width="100"></el-table-column>

    <!-- 借阅次数 -->
    <el-table-column prop="merchantName" label="商户名称" align="right" width="100">

    </el-table-column>

    <!-- 点赞次数 -->
    <!-- <el-table-column prop="foodName" label="菜单食物" align="right" width="100">

    </el-table-column> -->
    <el-table-column label="营业状态" align="right" width="100">
<template #default="scope">
  <span>{{ getStatusText(scope.row.status) }}</span>
</template>
</el-table-column>
    <!-- 操作 -->
    <el-table-column label="操作" width="160" align="center">
       <template #default="scope">
        <el-button
          type="text"
          size="small"
          class="blueBug"
          @click="changeHandle(scope.row)"
          icon="el-icon-edit"
        >
          修改
        </el-button>
        <el-button
          type="danger"
          size="small"
          class="delBut non"
          @click="deleteBookRank(scope.row.id)"
          icon="el-icon-delete"
        >
          改变状态
        </el-button>
      </template> 
    </el-table-column>
  </el-table>
      <el-pagination
        class="pageList"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="counts"
        @size-change="handleSizeChange"
        v-model:current-page="page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

  
  <!-- 对话框：编辑书籍排行榜信息 -->
  <el-dialog title="编辑餐厅信息" v-model="dialogTableVisible">
    <el-form label-width="120px" :model="bookRankMsg">
      <el-form-item label="餐厅序号:" style="width: 800px">
        <el-input disabled v-model="bookRankMsg.id" readonly></el-input>
      </el-form-item>
      <el-form-item label="餐厅名称:" style="width: 800px">
        <el-input v-model="bookRankMsg.restaurantName"></el-input>
      </el-form-item>
      <el-form-item
          label="详细地址"
          label-width="100px"
          prop="address1"
          clearable
        >
          <div style="width:90%;"> 
       
            <el-input placeholder="请选择地址"  v-model="bookRankMsg.restaurantAddr" @change="openMap()">
              <el-button slot="append" icon="el-icon-location" @click="openMap()"></el-button>
            </el-input>
            <!-- 添加一个 div 来展示 mapdata 的内容 -->
        <div v-if="mapdata.province || mapdata.city || mapdata.district" class="selected-address-info">
          <p><strong>省:</strong> {{ mapdata.province }}</p>
          <p><strong>市:</strong> {{ mapdata.city }}</p>
          <p><strong>区/县:</strong> {{ mapdata.district }}</p>
          <p><strong>经度:</strong> {{ mapdata.lat }}</p>
          <p><strong>纬度:</strong> {{ mapdata.lng }}</p>
        </div>
            <man ref="ms" @on-select="selectAddress" />
          </div>
        </el-form-item>
      <el-form-item label="餐厅电话:" style="width: 800px">
        <el-input v-model="bookRankMsg.restaurantPhone"></el-input>
      </el-form-item>
      <el-form-item label="餐厅营业状态:" style="width: 800px">
    <el-radio-group v-model="bookRankMsg.status">
        <el-radio :label="0">营业中</el-radio>
        <el-radio :label="1">歇业中</el-radio>
    </el-radio-group>
</el-form-item>
      <el-form-item label="餐厅照片:" style="width: 800px">
        <!-- 图片预览和删除按钮 -->
        <div v-if="bookRankMsg.image" class="preview-image">
          <img :src="bookRankMsg.image" alt="书籍照片" style="max-width: 30%; height: auto;" />
          <el-button type="danger" icon="el-icon-delete" circle @click="removeImage"></el-button>
        </div>
        <!-- 文件上传 -->
        <el-upload
          v-if="!bookRankMsg.image"
          action="http://localhost:8090/file/upload"
          :on-success="handleUploadSuccess"
          list-type="picture-card"
          :limit="1"
          :on-remove="removeImage"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogTableVisible = false">取 消</el-button>
      <el-button type="primary" @click="quedingEdit(bookRankMsg)">确 定</el-button>
    </span>
  </el-dialog>

  </div>


</template>

<script>
import axios from "axios";
import man from "../man.vue";

export default {
  components:{
  man
 },
  name: 'Manage',
  data() {
    return {
      tableData: [],
      typeNameArr: [],
      pagesize:10,
      page:1,
      input: '',
      counts:0,
      msg:"",
      dialogTableVisible:false,
      adminmsg:{
     id:'',
        userId:'',
        dormHao:'',
        dormDong:'',
        dormLou:"",
      },
      mapdata:{
      province: "",
      city: "",
      district: "",
      lat:0,
      lng:0
      },
      bookRankMsg: {
      id: null, // 排行序号
      restaurantName: '', // 书籍名称
      restaurantAddr: null, // 书籍号
      restaurantPhone: '', // 书籍类型
      image: null, // 借阅次数
      status: null // 点赞次数
    }
    }
  },



  mounted() {
    this.init()
  },
  methods: {

    init(){
      const params = {
        page: this.page,
        pagesize: this.pagesize,
        input: this.input ? this.input : undefined
      }
      axios.get('http://localhost:8090/mer/getMyRes',{
          params
        }
      )
        .then(response => {

          this.tableData=response.data.data.records
          this.counts=response.data.data.total
          // 请求成功时的处理逻辑
          console.log(this.tableData)

        })
        .catch(error => {
          // 请求失败时的处理逻辑
          console.error(error); // 输出错误信息
        });
    },

    //点击搜索执行方法即可
    sousuo(){
      this.init();

    },

    
openMap() {
  axios.get('/api/ws/geocoder/v1/', {
  params: {
    address: this.bookRankMsg.restaurantAddr,
    key: 'ZI7BZ-L6N34-SS7UQ-FT2UZ-GJ7M7-H7BUL'
  }
}).then(res => {
  this.mapdata=res.data.result.address_components
  this.mapdata.lat=res.data.result.location.lat
  this.mapdata.lng=res.data.result.location.lng
              // this.mapdata=res.result.location.address_components                        
                this.$refs.ms.setLocationByLatLng(res.data.result.location.lat, res.data.result.location.lng);     
        }).catch(err => {
            // search_btn.value = false
            console.log('地图错误：', err);
        })
			// 根据省市区设置初始值
			// this.$refs.ms.setLocationByAddress(this.mainForm.address);
			// 根据经纬度设置初始值
 
			// this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
		},
		
		// 地址选择后的回调函数
		selectAddress(address, lat, lng, province, city, area) {
      this.info.lat = lat;
      this.info.lng = lng;
      this.info.province = province;
      this.info.city = city;
      this.info.area = area;
      this.info.address = address;
      this.keyWord = address;
			// this.mainForm.address = address;
			// this.mainForm.lat = lat;
			// this.mainForm.lng = lng;
		},
    editBookRank(){
      this.init();

    },


    getStatusText(status) {
  switch (status) {
    case 0:
      return '营业中';
    case 1:
      return '歇业中';
    default:
      return '未知状态';
  }
},
//打开修改窗口
editadmin(data){
   this.adminmsg=data
      this.dialogTableVisible=!this.dialogTableVisible
    },



  




changeHandle(form){
this.msg="修改"
this.bookRankMsg=form
this.dialogTableVisible=!this.dialogTableVisible
},

addDOStu(){
this.msg="新增"
this.bookRankMsg={}
this.dialogTableVisible=!this.dialogTableVisible
},

quedingEdit(data){
  if(this.msg=="修改"){
      this.$confirm('确认修改该餐厅信息, 是否继续?', '确定修改', {
  'confirmButtonText': '确定',
  'cancelButtonText': '取消',
}).then(()=>{
  axios.post('http://localhost:8090/mer/updateRes',data)
    .then(response => {
      // 请求成功时的处理逻辑
      this.$message.success("修改成功！")
      this.dialogTableVisible=false
          this.init();
    })
    .catch(error => {
      // 请求失败时的处理逻辑
      console.error(error); // 输出错误信息
    });
})
    }
else{
this.$confirm('确认新增该餐厅信息, 是否继续?', '确定新增', {
  'confirmButtonText': '确定',
  'cancelButtonText': '取消',
}).then(()=>{
  axios.post('http://localhost:8090/mer/addRes',data)
    .then(response => {
      // 请求成功时的处理逻辑
      this.$message.success("新增成功！")
      this.dialogTableVisible=false
      this.init();
    })
    .catch(error => {
      // 请求失败时的处理逻辑
      console.error(error); // 输出错误信息
    });
})
} 
},


    addFoodtype(){
      console.log(666)
    },
    handleQuery(){
      console.log(666)
    },

  

deleteBookRank(data){
      this.$confirm('确认该本该餐厅状态, 是否继续?', '确定修改', {
        'confirmButtonText': '确定',
        'cancelButtonText': '取消',
      }).then(()=>{
        axios.get('http://localhost:8090/res/changeRes?id='+data)
          .then(response => {
            // 请求成功时的处理逻辑
            this.$message.success("修改成功！")
            this.dialogTableVisible=false
      this.init();
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      })
    },
    // 全部操作
    handleSelectionChange (val){
      let checkArr = []
      val.forEach((n) => {
        checkArr.push(n.id)
      })
      this.checkList = checkArr
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange (val) {
      this.page = val
      this.init()
    },
    removeImage() {
    this.bookRankMsg.image = ''; // 清空图片URL

  },
  
  handleUploadSuccess(response){

this.bookRankMsg.image=response.data
},
  }
}
</script>

<style lang="less" scoped>
.manage {
  padding: 16px;
}
</style>
